/**
 * useCartofactWells
 * Function as a side effect React hook to fetch Cartofact well data based on map state and update redux
 */

import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import debounce from 'lodash.debounce';

import { gisActions } from '../actions';

export default function useCartofactWells({
  toggleCartofactWells = true,
  boundingBox,
  filter,
  orderBy = null,
  fpzLine = null,
  operator = null,
  companyIds = null,
  companies = null,
}) {
  const dispatch = useDispatch();

  const fetchCartofactWells = useRef(
    debounce(async (params) => {
      // console.log('Fetching Cartofact wells with params:', params);
      try {
        const data = await gisActions.getCartofactWells(params);
        dispatch({ type: 'SET_CARTOFACT_WELLS', payload: data });
      } catch (err) {
        console.error('Cartofact fetch failed:', err);
        dispatch({ type: 'SET_CARTOFACT_WELLS', payload: [] });
      } finally {
        dispatch({ type: 'SET_LOADING', payload: false });
      }
    }, 1500),
    []
  ).current;

  useDeepCompareEffect(() => {
    if (toggleCartofactWells && boundingBox) {
      const params = { boundingBox, filter, abandoned: true, orderBy, fpzLine, operator, companyIds };

      dispatch({ type: 'SET_LOADING', payload: true });

      fetchCartofactWells(params);
    } else {
      dispatch({ type: 'SET_CARTOFACT_WELLS', payload: [] });
      dispatch({ type: 'SET_LOADING', payload: false });
    }
  }, [toggleCartofactWells, boundingBox, filter, operator, companyIds]);

  return null; // hook is effect-only now
}
